module.exports = __webpack_public_path__ + "static/media/overview_active.46a59375.svg";